import { NotificationData } from "../NotificationData";

export class NotificationActivityData extends NotificationData {
  setup(data: any) {
    super.setup(data);
    this.type = NotificationData.types.ACTIVITY;

    this.redirectPath = "/todos";
  }
}
